import axios from "../axios-auth";
import orginal_axios from "axios";

export const emrService = {
  getEMRList,
  saveEMR,
  getEMRDetail,
  printEMRInvoice,
  showWindowDialog
};

function getEMRList(searchParams, page, size, sortedBy) {
  if (!page) {
    page = 0;
  } else {
    page -= 1;
  }
  if (!size) {
    size = 50;
  }

  let params = {
    page: page,
    size: size,
    sort: sortedBy
  };


  if (searchParams.fromDate) {
    params["fromDate"] = searchParams.fromDate;
  }

  if (searchParams.toDate) {
    params["toDate"] = searchParams.toDate;
  }

  if (searchParams.issueNo) {
    params["issueNo"] = searchParams.issueNo;
  }

  if (searchParams.departmentId) {
    params["departmentId"] = searchParams.departmentId;
  }

  if (searchParams.status) {
    params["status"] = searchParams.status;
  }

  if (searchParams.reason) {
    params["reason"] = searchParams.reason;
  }

  if (typeof (searchParams.isAddDetails) == 'boolean') {
    params["isAddDetails"] = searchParams.isAddDetails;
  }

  if (searchParams.shopId) {
    params["shopId"] = searchParams.shopId;
  }

  if (searchParams.warehouseId) {
    params["warehouseId"] = searchParams.warehouseId;
  }

  if (searchParams.binId) {
    params["binId"] = searchParams.binId;
  }

  if (searchParams.stockWarehouseId) {
    params["stockWarehouseId"] = searchParams.stockWarehouseId;
  }

  if (searchParams.stockBinId) {
    params["stockBinId"] = searchParams.stockBinId;
  }

  if (searchParams.serialNo) {
    params["serialNo"] = searchParams.serialNo;
  }

  if (searchParams.binIds) {
    params["binIds"] = searchParams.binIds.join();
  }

  if (searchParams.type) {
    params["type"] = searchParams.type;
  }

  if (searchParams.isFinishedProduction) {
    params["isFinishedProduction"] = searchParams.isFinishedProduction;
  }

  if (typeof (searchParams.checkLocationMovement) == 'boolean') {
    params["checkLocationMovement"] = searchParams.checkLocationMovement;
  }

  return axios.get("/auth/emrs", { params });
}

function saveEMR(EMR) {
  if (!EMR.id) {
    // new emr
    return axios.post("/auth/emr", EMR);
  } else {
    // edit
    return axios.put("/auth/emr", EMR);
  }
}

function getEMRDetail(id, isAddDetails) {
  let params = {};
  if (isAddDetails) {
    params["isAddDetails"] = isAddDetails;
  }
  return axios.get("/auth/emr/" + id, { params });
}

function printEMRInvoice(id) {
  return orginal_axios({
    url: axios.defaults.baseURL + "/auth/print-emr-invoice/" + id,
    method: "GET",
    responseType: "arraybuffer", // important
    headers: {
      Authorization: "Bearer " + localStorage.getItem("accessToken"),
      Accept: "application/pdf",
      "Content-Type": "application/json"
    }
  }).then(function (response) {
    return new Blob([response.data], { type: "application/pdf" });
  });
}

function showWindowDialog(blob, fileName) {
  // IE doesn't allow using a blob object directly as link href
  // instead it is necessary to use msSaveOrOpenBlob
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(blob);
    return;
  }

  // For other browsers: 
  // Create a link pointing to the ObjectURL containing the blob.
  const data = window.URL.createObjectURL(blob);
  var link = document.createElement(fileName);
  link.href = data;
  link.download = fileName + ".pdf";
  window.open(link.href, fileName, "width=500,height=500");

  setTimeout(function () {
    // For Firefox it is necessary to delay revoking the ObjectURL
    window.URL.revokeObjectURL(data);
  }, 100);
}
